import { Box, Button, Grid, Paper } from "@material-ui/core";
import { Dispatch } from "react";
import { SetStateAction } from "react";
import { useCastersContext } from "../../CastersContext";
import { useTableStyles } from "../../styles/useTableStyles";
import { NumberTextFieldDE } from "../form-fields/common/NumberTextFieldDE";
import { SelectorFieldDE } from "../form-fields/common/SelectorFieldDE";
import { useFormHandlers } from "../hooks/useFormHandlers";

interface Props {
	reloadProcess: Function;
	refreshData: Function;
	setPourbackModalOpen: Dispatch<SetStateAction<boolean>>;
}
export const PourbackFields = ({
	reloadProcess,
	refreshData,
	setPourbackModalOpen,
}: Props) => {
	const { state, actions } = useCastersContext();
	const process = state.processData;
	const tonnageReasons = state.tonnageReasons;
	const classes = useTableStyles();

	const { handleOptionValueChanged } = useFormHandlers({
		reloadProcess,
		refreshData,
	});

	return (
		<Paper elevation={0} className={classes.borderAgGridTable}>
			<Box padding={1}>
				<Grid
					container
					direction="row"
					spacing={1}
					justifyContent="center"
					alignItems="center"
				>
					{/* Pourback Weight */}
					<Grid item xs={6}>
						<NumberTextFieldDE
							label="Pourback Weight [tons]"
							value={process?.PourbackWeight ?? 0}
							disabled={true}
							onChange={(val) => {}}
							onBlur={() => {}}
							pause={() => actions.setRefreshInPause(true)}
							resume={() => actions.setRefreshInPause(false)}
						/>
					</Grid>

					{/* Declare Pourback Button */}
					<Grid item xs={6}>
						<Button
							variant="contained"
							color="primary"
							style={{ height: "33px" }}
							disabled={!process?.HeatId}
							fullWidth
							onClick={() => {
								setPourbackModalOpen(true);
								actions.setRefreshInPause(true);
							}}
						>
							Declare Pourback
						</Button>
					</Grid>
					{/* Low Tonnage Reason Selector */}
					<Grid item xs={12}>
						<SelectorFieldDE
							label="Low Tonnage Reason"
							value={process?.LowTonnageReasonId || ""}
							options={
								tonnageReasons
									? tonnageReasons.map(
											({ LowTonnageReasonId, LowTonnageReasonName }) => ({
												value: LowTonnageReasonId,
												label: LowTonnageReasonName,
											}),
										)
									: []
							}
							onChange={(value) => {
								actions.setRefreshInPause(false);
								handleOptionValueChanged("LowTonnageReasonId", value);
							}}
							disabled={false}
							nullable={true}
							onBlur={() => actions.setRefreshInPause(true)}
							onFocus={() => actions.setRefreshInPause(false)}
						/>
					</Grid>
				</Grid>
			</Box>
		</Paper>
	);
};
